<template>
  <div>
    <swiper-banner />
    <card />
    <service />
    <!-- <information /> -->
    <new-information />
  </div>
</template>

<script>
import swiperBanner from '@/components/index/swiperBanner';
import card from '@/components/index/card';
import service from '@/components/index/service';
import information from '@/components/index/information';
import newInformation from '@/components/index/newInformation';
export default {
  name: 'index',
  data () {
    return {

    };
  },
  created () {
  },
  components: {
    swiperBanner,
    card,
    service,
    information,
    newInformation
  }
};
</script>

<style lang="scss">
.el-input__inner:focus {
  border-color: $el-main-color !important;
}

.el-textarea__inner:focus {
  border-color: $el-main-color !important;
}

.el-radio__input.is-checked .el-radio__inner {
  border-color: $el-main-color;
  background: $el-main-color;
}

.el-radio__input.is-checked+.el-radio__label {
  color: $el-main-color;
}

.el-upload--picture-card:hover {
  border-color: $el-main-color;
}

.el-select-dropdown__item.selected {
  color: $el-main-color;
}

.el-select .el-input.is-focus .el-input__inner {
  border-color: $el-main-color;
}

.el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: $el-main-color;
  background: $el-main-color;
}

.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: $el-main-color;
}

.el-radio__inner:hover {
  border-color: $el-main-color;
}

.el-checkbox__inner:hover {
  border-color: $el-main-color;
}

.el-checkbox__input.is-checked+.el-checkbox__label {
  color: $el-main-color;
}</style>



// WEBPACK FOOTER //
// src/pages/index.vue